import {Descriptions as AntdDescriptions} from 'antd';
import styles from './Descriptions.module.scss';

const Descriptions = ({loading, children, className, ...props}) => (
  <div style={{overflowX: 'auto'}}>
    <AntdDescriptions
      {...props}
      className={[styles.descriptions, className]}
    >
      {children}
    </AntdDescriptions>
  </div>
);

Descriptions.Item = ({children, ...props}) => (
  // eslint-disable-next-line react/no-children-prop
  <AntdDescriptions.Item {...props} children={children}/>
);

export default Descriptions;
